import SeoMeta from 'components/Basic/Head/SeoMeta';
import Brands from 'components/Pages/Brands';
import { BrandsQueryDocumentApi, BrandsQueryVariablesApi } from 'graphql/generated';
import { initServerSideProps, ServerSidePropsType } from 'helpers/InitServerSideProps';
import { getServerSidePropsWrapper } from 'helpers/serverSide/getServerSidePropsWrapper';
import { useGtmStaticPageView } from 'hooks/gtm/useGtmStaticPageView';
import useTranslation from 'next-translate/useTranslation';
import { NextPageExtended } from 'types/global';
import { useGtmStaticPageViewEvent } from 'utils/Gtm/EventFactories';

const Index: NextPageExtended<ServerSidePropsType> = () => {
    const { t } = useTranslation();
    const gtmStaticPageViewEvent = useGtmStaticPageViewEvent('other');
    useGtmStaticPageView(gtmStaticPageViewEvent);

    return (
        <>
            <SeoMeta title={t('Brands')} />
            <Brands />
        </>
    );
};

Index.layout = 'withLastVisitedProducts';

export const getServerSideProps = getServerSidePropsWrapper(({ domainConfig, redisClient, t }) => async (context) => {
    return initServerSideProps<BrandsQueryVariablesApi>({
        context,
        domainConfig,
        redisClient,
        t,
        prefetchedQueries: [{ query: BrandsQueryDocumentApi }],
    });
});

export default Index;
